@if (showTools) {
<huge-row
	class="graph-top-buttons"
>
	<tools-time-frame-selector
		class="pull-left"
		[selectedInterval]="graphData.Interval"
		[selectedTimeFrame]="graphData.TimeFrame"
		[selectedTimePeriod]="graphData.Timeperiod"
		(intervalChanged)="intervalInputChanged($event)"
		(timeFrameChanged)="timeFrameSelected($event)"
		(timePeriodChanged)="timePeriodSelected($event)"></tools-time-frame-selector>
	<span
		matTooltip="Reload the graph with the current options"
		class="pull-right pointer refresh-icon"
		(click)="emitToParent()">
		<i class="material-icons">refresh</i>
	</span>
</huge-row>
}
<div style="width: 100%">
	<app-generic-graph
		#GraphChild
		[enableDataLabels]="enableDataLabels"
		[showDataLables]="showDataLabels"
		[colors]="colors"
		[formatXAxisDate]="formatXAxisDate"
		(selected)="notify($event)"></app-generic-graph>
</div>
